export const NotFound = () => <h1>Nothing to see here</h1>;
